module.exports = __webpack_public_path__ + "img/13.ea593bf9.png";